module.exports = __webpack_public_path__ + "img/logo-lsu.b2a2a61a.png";